import { forwardRef, useRef, useState, useEffect } from 'react';
import { Form, Button } from 'react-bootstrap';

export const ImageFileInput = forwardRef(({ accept = 'image/*', maxSize = 5 * 1024 * 1024, onImageSelect }, ref) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [error, setError] = useState(null);
  const fileInputRef = useRef();

  const validateImage = (file) => {
    setError(null);

    if (!['image/png', 'image/jpeg', 'image/jpg'].includes(file?.type)) {
      setError(__('File type not supported'));
      return null;
    }

    if (file.size > maxSize) {
      setError(__('File size exceeds the maximum allowed size'));
      return null;
    }

    return file;
  };

  const handleFileChange = (event) => {
    const file = validateImage(event.target.files[0]);
    setSelectedImage(file);

    if (onImageSelect) {
      onImageSelect(file);
    }
  };

  useEffect(() => {
    if (selectedImage) {
      const url = URL.createObjectURL(selectedImage);
      setPreviewUrl(url);
    }
    else if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
    }

    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [selectedImage]);

  return (
    <div>
      <Form.Control ref={fileInputRef} type="file" accept={accept} onChange={handleFileChange} style={{ display: 'none' }} />

      <div className="d-flex align-items-center gap-2">
        <Button variant="outline-primary" onClick={() => fileInputRef.current?.click()}>
          {selectedImage ? __('Change Image') : __('Choose Image')}
        </Button>
      </div>

      {error && (<Form.Control.Feedback type="invalid" className="d-block">{error}</Form.Control.Feedback>)}

      {previewUrl && (
        <div className="mt-2">
          <img src={previewUrl} alt="Preview" style={{ maxWidth: '200px', maxHeight: '200px', objectFit: 'contain' }} className="border rounded" />
        </div>
      )}

      {selectedImage && (
        <div className="flex-grow-1">
          <small className="text-muted">{selectedImage.name} ({(selectedImage.size / 1024 / 1024).toFixed(2)} MB)</small>
        </div>
      )}

    </div>
  );
}); 